import React from 'react'
import { isFramed } from '../../../utils/isFramed'

const BBB_SEAL_SRC = 'https://seal-newyork.bbb.org/frame/ruhzbum/bbb-87145750.png?chk=D4ED1B81F1'

export const BBBBadge = () => {
  const { height, width } = isFramed() ? { height: 68, width: 150 } : { height: 84, width: 170 }

  return (
    <iframe
      className="trust-signals__bbb"
      title="SmartAsset BBB Business Review"
      src={BBB_SEAL_SRC}
      frameBorder="0"
      scrolling="no"
      style={{ border: 0, height, width, transform: 'translateY(10px)' }}
    />
  )
}
